export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/a0758b19affa762b50cdce723f4b73ca.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="px-4 py-2 bg-[#06B6D4]/20 border border-[#06B6D4] text-[#06B6D4] rounded-full text-sm font-medium backdrop-blur-sm">
                Enterprise VPN Solution
              </span>
            </div>

            <h2 className="text-6xl md:text-7xl font-bold text-white leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              Secure Your
              <br />
              Digital
              <br />
              Privacy
            </h2>

            <p className="text-xl text-gray-200 leading-relaxed max-w-xl">
              Military-grade encryption protecting your online activities across all devices
            </p>

            <button
              onClick={scrollToContact}
              className="group px-8 py-4 bg-[#06B6D4] text-white rounded-lg font-semibold text-lg hover:bg-[#0891B2] transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <span>Get Started</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          <div className="hidden md:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20isometric%20illustration%20of%20VPN%20tunnel%20concept%20with%20glowing%20cyan%20data%20streams%2C%20floating%20lock%20icons%20and%20shield%20symbols%2C%20connected%20device%20nodes%20showing%20laptop%20and%20smartphone%2C%20purple%20and%20cyan%20accent%20colors%2C%20dark%20background%20with%20geometric%20shapes%2C%20modern%20cybersecurity%20visualization%2C%20clean%20minimalist%20tech%20illustration&width=800&height=800&seq=hero-illustration-001&orientation=squarish"
                alt="VPN Security Illustration"
                className="w-full h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
